var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import clsx from 'clsx';
import { XIcon } from '../icon/XIcon';
import { XBox } from '../box/XBox';
import { preventClick } from '../../../util/preventClick';
import { XRouterLink } from '../router/XRouterLink';
export function XList(_a) {
    var title = _a.title, items = _a.items;
    var _b = useState({}), itemState = _b[0], setItemState = _b[1];
    return (React.createElement("div", { className: clsx('XList') },
        title && React.createElement("label", { className: "title" }, title),
        React.createElement("div", { className: "items-container" }, items.map(function (item) {
            var key = item.title;
            var Element = 'div';
            var elementProps = {};
            var contentRight;
            function handleClick() {
                var _a;
                if (item.type === 'toggle') {
                    var _b = item, isActive = _b.isActive, onChangeValue = _b.onChangeValue;
                    onChangeValue(!isActive);
                }
                (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
            }
            if (item.type === 'toggle') {
                var isActive = item.isActive;
                contentRight = (React.createElement("div", { className: "switch" },
                    React.createElement("input", { type: "checkbox", checked: isActive, onClick: preventClick, onChange: function () { } }),
                    React.createElement("span", { className: "slider round" })));
            }
            else if (item.type === 'values') {
                var _a = item, value = _a.value, _b = _a.values, values = _b === void 0 ? [] : _b;
                if (value) {
                    contentRight = React.createElement("div", null, value);
                }
                else {
                    var valueCount_1 = values.length || 0;
                    var keyActiveIndex_1 = key + "_activeIndex";
                    var activeIndex_1 = itemState[keyActiveIndex_1] || 0;
                    item.onClick = function () {
                        var _a;
                        setItemState(__assign(__assign({}, itemState), (_a = {}, _a[keyActiveIndex_1] = activeIndex_1 + 1 < valueCount_1 ? activeIndex_1 + 1 : 0, _a)));
                    };
                    contentRight = React.createElement("div", null, values[activeIndex_1]);
                }
            }
            else if (item.type === 'nav') {
                var to = item.to;
                Element = XRouterLink;
                elementProps.to = to;
                contentRight = React.createElement(XIcon, null, "keyboard_arrow_right");
            }
            return (React.createElement(Element, __assign({ onClick: handleClick, className: clsx('item', item.type) }, elementProps, { key: key }),
                item.icon && React.createElement(XIcon, { className: "icon-left" }, item.icon),
                React.createElement(XBox, { flex: true, gap: 2, className: "item-content" },
                    React.createElement("div", null,
                        React.createElement("div", null, item.title),
                        item.subtitle && React.createElement("div", { className: "subtitle" }, item.subtitle)),
                    React.createElement(XBox, { flex: true, align: "center", gap: 1, className: "content-right" },
                        item.value && React.createElement("div", { className: "content-right-value" }, item.value),
                        contentRight))));
        }))));
}
